const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to reset password
const G2ReviewUrlApi = async (
    partner_name: string, //partner_name name
    email:string //
): Promise<any> => {

    try {
        // Step 1: Request review token using fetch
    const response = await fetch(
      `${baseURL}/g2-review-request`,
      {
        method: "POST"
      }
    );

    const data = await response.json();
    const state = data.state;

    // Step 2: Create review form URL
    const reviewUrl =
    `https://www.g2.com/partnerships/${partner_name}/users/login.embed` +
    `?state=${state}&email=${encodeURIComponent(email)}`;
    
    return reviewUrl ;
    } catch (error) {
        return Promise.reject;
    }

}

const G2ReviewRequestApi = async (
    email:string //
): Promise<any> => {
    const formData = new FormData();

    formData.append("email", email);

    try {
        // Step 1: Request review token using fetch
    const response = await fetch(
      `${baseURL}/g2-review-status`,
      {
        method: 'POST',
        body: formData
      }
    );

    return await response.json();
    } catch (error) {
        return Promise.reject;
    }

}

export {G2ReviewUrlApi, G2ReviewRequestApi}